module.exports = __webpack_public_path__ + "static/media/water.ab52045c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/water.jpg
// module id = 567
// module chunks = 6